import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const stockIn = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        // {
        //     title: '操作',
        //     key: 'operation',
        //     scopedSlots: {customRender: 'operation'},
        //     width: 100
        // },
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'id',
        //     sorter: true,
        //     sortDirections: ["descend", "ascend", "descend"]
        // },
        {
            title: '物料名称',
            dataIndex: 'materialLexiconDTO.materialName',
            key: 'materialName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'materialName'
            },
            filteredValue: filteredInfo.materialName || [],
        },
        {
            title: '物料类型',
            dataIndex: 'materialLexiconDTO.materialType',
            key: 'materialType',
            scopedSlots: {
                customRender: 'materialType'
            },
        },

        {
            title: '物料数量',
            dataIndex: 'number',
            key: 'number',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.number || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },

        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy|| [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
